<template>
  <app-page-wrapper-grid>
    <div>
      <h1>Help page</h1>
    </div>
  </app-page-wrapper-grid>
</template>

<script>
export default {
  name: "Help"
};
</script>

<style scoped></style>
